// extracted by mini-css-extract-plugin
export default {"teamInfo":"LiveScoreTeam_teamInfo__PlT2Z","goalScored":"LiveScoreTeam_goalScored__Wk8N-","halfTime":"LiveScoreTeam_halfTime__alFD1","tagWinner":"LiveScoreTeam_tagWinner__kl901"};